module.exports = __webpack_public_path__ + "static/media/image_32.962fe1a2.png";